import React from 'react';

function Loader() {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
      <div className="flex justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-[4px] border-primary border-t-transparent"></div>
      </div>
    </div>
  );
}

export default Loader;
